import { render, staticRenderFns } from "./indexBanner.vue?vue&type=template&id=037695b4&scoped=true&"
import script from "./indexBanner.vue?vue&type=script&lang=js&"
export * from "./indexBanner.vue?vue&type=script&lang=js&"
import style0 from "./indexBanner.vue?vue&type=style&index=0&id=037695b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037695b4",
  null
  
)

export default component.exports